import { defineStore } from "pinia"
import reduce from 'lodash/reduce'
import union from 'lodash/union'
import { IMAGE_FILTER, YARN_STATUS, CARD_LIMIT, FABRIC_UNIT_LIST, limitOptions } from '~/constants/common.js'

export const useStorageStore = defineStore("storage", () => {
  const { locale } = useI18n()
  const yarnStore = useYarnStore()
  const storage = ref('localStorage')
  const showImageFilter = ref(false)
  const imageFilter = ref(IMAGE_FILTER.THUMBNAIL)
  const searchCondition = ref(getSearchInitValue())
  const keywordHistory = ref([])
  const searchListWholeCount = ref(0)
  const searchColorWholeCount = ref(1)
  const listByCompany = ref([])
  const searchList = ref([])
  const sortBy = ref(null)
  const searchStore = useSearchStore()
  const searchColorList = ref([])
  const currentPage = ref(0)
  const clickedColorId = ref(null)
  const fabricZoom = ref(1)
  const fabricUnit = ref(FABRIC_UNIT_LIST[0])
  const fabricUnitList = ref([])
  const mailHistoryLimit = ref(limitOptions[0])
  const invitedUser = ref({})
  const loadedSearch = ref(false)

  const getSearchList = async ({ page = 1, isMyYarnPage = false, callback, companyId, currLocale }) => {
    let localeVar = currLocale ?? locale.value
    let yarnStatus = ''
    let limit = 0
    let sort = -1
    const baseStore = useBaseStore()
    const searchStore = useSearchStore()
    
    loadedSearch.value = false

    if (isMyYarnPage) {
      limit = 23
      sort = searchStore.sortByYarnPage || parseInt(localStorage.getItem('sortByYarnPage')) || 28001
      if (searchCondition.value && searchCondition.value.status){
        yarnStatus = searchCondition.value.status.join()
      } else {
        yarnStatus = null;
      }
    } else {
      sort = sortBy.value || parseInt(localStorage.getItem('sortBy')) || 28008
      yarnStatus = YARN_STATUS.PUBLIC.toString()
      limit = CARD_LIMIT
    }
    baseStore.setSpinner()
    await usePost('/yarn/q/s', {
      ...provideMappedSearch(searchCondition.value || getSearchInitValue()),
      page,
      limit: limit,
      sort: sort,
      locale: localeVar,
      yarnStatus: yarnStatus,
      isMyYarnPage,
      companyId
    }).then((res) => {
      if (!isMyYarnPage) {
        searchList.value = res.data.data.data
        searchListWholeCount.value = res.data.data.total
      } else {
        yarnStore.$patch({
          listByCompany: res.data.data.data,
          listByCompanyCount: res.data.data.total
        })
        const statusMap = res.data.data.data.reduce((final, each) => {
          return [...final, {
            yarnId: each.yarnId,
            yarnStatus: each.yarnStatus
          }]
        }, []);
        yarnStore.$patch({ yarnStatusMap: statusMap })
      }
    }).catch(err => {
      return err
    }).finally(() => {
      loadedSearch.value = true
      baseStore.hideSpinner()
    })
  }

  const getSearchColorList = async ({ page = 1, isMyYarnPage, callback, companyId }) => {
    let limit = 0
    let yarnStatus=""
    const baseStore = useBaseStore()

    if (!isMyYarnPage) {
      limit = CARD_LIMIT
      yarnStatus = YARN_STATUS.PUBLIC.toString()
    } else {
      limit = 23
      if (searchCondition.value && searchCondition.value.status){
        yarnStatus = searchCondition.value.status.join()
      } else {
        yarnStatus = null;
      }
    }
    const params = {
      ...provideMappedSearch(searchCondition.value || getSearchInitValue()),
      limit,
      page,
      locale: locale.value,
      isMyYarnPage,
      companyId
    }
    delete params.colored
    params.colors = params.colors || '1'
    if (Object.keys(searchCondition.value).length) {
      baseStore.setSpinner()
      await usePost('/yarn/color/q/s', {
        ...params,
        yarnStatus,
        limit: limit,
        sort: searchStore.sortBy,
        isMyYarnPage
      },
      ).then((res) => {
        if (!isMyYarnPage) {
          searchColorList.value = res.data.data.data
          searchColorWholeCount.value = res.data.data.total
        } else {
          yarnStore.$patch({
            listByCompanyCount: res.data.data.total,
            listByCompany: res.data.data.data,
          })
          const yarnStatusMap = res.data.data.data.reduce((final, each) => {
            return [...final, {
              yarnId: each.yarnId,
              yarnStatus: each.yarnStatus
            }]
          }, []);
          yarnStore.$patch({ yarnStatusMap: yarnStatusMap })
        }
      }).catch(err => {
        return err
      }).finally(() => {
        baseStore.hideSpinner()
      })
    }
  }

  const addKeywordSearchResult = (newOne) => {
    const copiedState = JSON.parse(JSON.stringify(keywordHistory.value))
    const newHistory = union([newOne, ...copiedState])
    newHistory.length = 20
    keywordHistory.value = newHistory
  }

  return {
    storage,
    imageFilter,
    showImageFilter,
    keywordHistory,
    searchCondition,
    searchListWholeCount,
    searchColorWholeCount,
    searchList,
    clickedColorId,
    searchColorList,
    currentPage,
    fabricZoom,
    fabricUnit,
    fabricUnitList,
    mailHistoryLimit,
    getSearchList,
    getSearchColorList,
    addKeywordSearchResult,
    invitedUser,
    loadedSearch
  }
}, {
  persist: true
})
